import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Translate } from "react-localize-redux";
import { Spin } from "antd";
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import UserAction from "src/redux/UserActions";
import { UserState } from "src/redux/UserReducer";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import { PageProps } from "src/models/common/ComponentProps";
import FullscreenApi from "src/utils/FullscreenHelper";
import ConfigureHistory from "src/core/ConfigureHistory";

interface LogoutProps extends PageProps<{}> {
    // From Redux
    User: UserState;
    logoutUser: () => Promise<void>;
}

class Logout extends React.Component<LogoutProps> {
    constructor(props: LogoutProps) {
        super(props);
        bindAllOfThis(this, Logout.prototype);
    }

    componentDidMount(): void {
        // This will empty to the redux cache and send user to login land
        this.props.logoutUser().then(() => {
            FullscreenApi.CancelFullscreen();
            ConfigureHistory.push(Routes.LOGIN);
        });
    }

    render() {
        return (<div>
            <Spin />
            <span><Translate id={""} /></span>
        </div>);
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        logoutUser: () => UserAction.LogoutUser(dispatch),
    });
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/pages/account/Logout.tsx